<!--
  功能：资产
  作者：lost
  邮箱：lost@daoyoudao.com
  时间：2022年03月09日 14:40:25
  版本：v1.0
-->
<template>
<div>
    <router-view></router-view>
</div>
</template>

<script>
export default {
  // 组件名称
  name: 'assetsindex',
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
    return {}
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {},
  // 组件在内存中被创建
  created () {
  },
  /**
  * 组件被渲染到页面
  */
  mounted () {
  }
}
</script>

<style lang='less' scoped>

</style>



// WEBPACK FOOTER //
// src/views/qianchuan/assets/index.vue